<div class="dialog-header">
  <button
    class="close-button"
    mat-icon-button
    tabindex="-1"
    cdkFocusInitial
    (click)="closeDialog()"
  >
    <i class="bosch-ic bosch-ic-clickable bosch-ic-close"></i>
  </button>
  <!-- <h3>{{ "platform-news.title" | translate }}</h3> -->
</div>

<div class="dialog-content">
  <div class="image-wrapper" *ngIf="imageBannerPath">
    <img
      class="banner"
      [src]="imageBannerPath"
      [attr.alt]="'platform-news.title' | translate"
    />
  </div>
</div>

<div class="dialog-actions">
  <button mat-button (click)="closeDialog()">
    {{ "button-close" | translate }}
  </button>
  <button
    mat-raised-button
    color="primary"
    (click)="redirectToServiceRequest()"
  >
    {{ "platform-news.schedule-service-request" | translate }}
  </button>
</div>
